import { parseISO as datefnsParse } from 'date-fns'

export const parse = datefnsParse
